import Compressor from 'compressorjs';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import _ from 'lodash';
import { getManifestPath } from '../../cnr/contexts/ManifestContext';
import { getFirstObject } from '../../common/convert';
import { createManifestIcons, createThumbnailIcons } from '../../components/imaging/createManifestIcons';
import { convertCanvasToFile } from '../../components/imaging/imageHelpers';
import { gEnums } from '../../enums/globalEnums';
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths';
import { deleteStorageProfileFolder } from '../../storage/removeStorage';
import { _storageSettings } from '../../storage/storageHelpers';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from './reducerHelpers/dispatchProps';

// import { deleteStorageFolder } from '../../functions/fbBucketFunctions';

const rts = {
  test: 'test',
  handleAmmend_allFiles: 'handleAmmend_allFiles',
  handleAmmend_manifestFiles: 'handleAmmend_manifestFiles',
  handleAccept: 'handleAccept',
  handleChange: 'handleChange',
  handleCloseUpdate: 'handleCloseUpdate',
  handleDecline: 'handleDecline',
  handleFileFormData: 'handleFileFormData',
  handleImageButtonFileSelect: 'handleImageButtonFileSelect',
  handleImageFileSelect: 'handleImageFileSelect',
  handleManifestFiles: 'handleManifestFiles',
  // handleUpload_manual: 'handleUpload_manual',
  handleUpload_allFiles: 'handleUpload_allFiles',
  // handleUpload_alpha: 'handleUpload_alpha',
  handleUpload_item: 'handleUpload_item',
  handleProgress: 'handleProgress',
  handleSet_allFiles: 'handleSet_allFiles',
  handleSet_avatorEditor: 'handleSet_avatorEditor',
  handleSet_imageImage: 'handleSet_imageImage',
  handleShowModalAlert: 'handleShowModalAlert',
  handleUpdate_currentGalleryStatus: 'handleUpdate_currentGalleryStatus',
  handleUpdate_galleryDir: 'handleUpdate_galleryDir',
  handleUpdate_pendingFiles: 'handleUpdate_pendingFiles',
  handleUpdate_singleItemStatus: 'handleUpdate_singleItemStatus',
  handleUpload_manifest: 'handleUpload_manifest',
  handleUploadResponse: 'handleUploadResponse',
  handleInit_upload: 'handleInit_upload',
  ...grts
}

export const uploadStatusTypes = {
  completed: 'completed',
  failed: 'failed',
  pending: 'pending',
}

export const fileStatusTypes = {
  approved: 'approved',
  existing: 'existing',
  found: 'found',
  missing: 'missing',
}

export const uploadReducer = (state, action) => {

  const { type, dispatch } = action
  const {
    files_info,
    altItemData,
    appUserAccess,
    formData,
    galleries,
    manifestFiles,
    pathViews,
    productionSettings,
    storageLocationType,
    storageRef,
    storageType,
    mainStorage,
  } = state

  const { selectedFolderFiles, pendingFiles } = files_info ?? {}

  const { found } = pendingFiles ?? {}

  let _storageRefProd = ''

  const callback_afterUpload = () => {
    // storage_handlers && storage_handlers.handleClear_gallery && storage_handlers.handleClear_gallery()
    // handleCancel_showUpload && handleCancel_showUpload()
    dispatch({ type: rts.updateSuccess, dispatch })
  }

  if (productionSettings && productionSettings.clientKey && storageRef) {
    const sr = storageRef.split('/')
    sr.forEach((s, index) => {
      switch (index) {
        case 1:
          _storageRefProd += productionSettings.clientKey ? productionSettings.clientKey : s
          break;
        default:
          _storageRefProd += s
      }
      if (index < sr.length - 1) {
        _storageRefProd += '/'
      }
    })
  }

  // internal handlers
  const { handleCloseUpdate, handleUpload_manifest, handleStartUpdate, handleManifestFiles, handleSet_allFiles } = dispatch ? uploadHandlers(dispatch) : {}

  switch (type) {
    case rts.test:
      break;

    case rts.handleInit_upload:

      const { initState } = action

      const {
        appUserAccess: aua,
        appUserCollection,
        currentPageData,
        dataItem,
        lastView,
        storageLocationType: slt,
        storageOptions,
        storagePaths,
        storageType: st,
        useClientProfileImage,
        view,
        viewItemKey,
        viewKey,
        viewListData,
      } = initState

      const _sp = {
        _viewItemKey: viewItemKey,
        appUserAccess: aua,
        appUserCollection,
        currentPageData,
        dataItem,
        lastView,
        pathViews,
        storageLocationType: slt,
        storageOptions,
        storagePaths,
        storageType: st ? st : gEnums.storageTypes.image,
        useClientProfileImage,
        useDarkMode: false,
        viewItem_id: viewKey,
        viewItem_key: view,
        viewListData,
      }
      const sgps = storageGalleryProps(_sp)
      const { useDarkMode, storageRef: sr, storageLocationType: _slt } = sgps ?? {}
      return { ...state, ...initState, storageRef: sr, useDarkMode, storageLocationType: _slt }

    case rts.handleImageButtonFileSelect:
      ammendSelectedFiles(action, [action.f], handleSet_allFiles, handleManifestFiles)
      return state

    case rts.handleImageFileSelect:
      const { target: { files } } = action.e;
      ammendSelectedFiles(action, files, handleSet_allFiles, handleManifestFiles)
      return state

    case rts.handleUpload_allFiles:
      if (state.allFiles) {
        uploadFilesPromise(mainStorage, { callback: callback_afterUpload, autoReduceImage: true, ignoreFileKey: true, action: {}, allFiles: state.allFiles, appUserAccess, storageRef, handleStartUpdate, storageLocationType, _storageRefProd, formData })
      }
      return state

    // case rts.handleUpload_manual:
    //   if (action.useAvatar && action.canvas) {
    //     const file = convertCanvasToFile(action.canvas)
    //     if (file) {
    //       // this is the fileName
    //       getFileName(file, storageLocationType, selectedFolderFiles, altItemData, formData)
    //       file.metadata = { name: 'test' }
    //       const sfp = { file, fileKey: file.name, appUserAccess, storageRef, handleStartUpdate, _storageRefProd, formData }
    //       uploadSingleFile(mainStorage, sfp)
    //     }
    //   } else {
    //     switch (storageType) {
    //       case gEnums.storageTypes.manifest:
    //         handleUpload_manifest(manifestFiles)
    //         break;

    //       default:
    //         const { currentPageData } = action
    //         // const _asf = {}
    //         const _formData = currentPageData ? currentPageData : formData
    //         const _asf = getUpdateList(selectedFolderFiles, currentPageData)

    //         switch (storageLocationType) {
    //           case gEnums.storageLocationTypes.clientProfile:
    //             deleteStorageProfileFolder(mainStorage, storageRef).then(res => {
    //               uploadAllFilesPromise(mainStorage, { callback: callback_afterUpload, autoReduceImage: true, ignoreFileKey: true, action: {}, files: _asf, appUserAccess, storageRef, handleStartUpdate, storageLocationType, _storageRefProd, formData: _formData })
    //             })
    //             break;
    //           default:
    //             uploadAllFilesPromise(mainStorage, { callback: callback_afterUpload, autoReduceImage: true, ignoreFileKey: true, action: {}, files: _asf, appUserAccess, storageRef, handleStartUpdate, storageLocationType, _storageRefProd, formData: _formData })

    //         }
    //         return state
    //     }
    //   }
    //   return state

    // case rts.handleUpload_alpha:
    //   const { fileList, useEmail } = action
    //   if (fileList) {
    //     const updateList = getUploadApprovedList(fileList, useEmail)
    //     if (!_.isEmpty(updateList)) {
    //       uploadAllFilesPromise(mainStorage, {
    //         callback: handleCloseUpdate ? handleCloseUpdate : callback_afterUpload,
    //         action,
    //         files: updateList,
    //         appUserAccess,
    //         storageRef: action.storageRef,
    //         handleStartUpdate,
    //         storageLocationType,
    //         _storageRefProd
    //       })
    //     }
    //   }

    //   return state

    case rts.handleUpload_item:
      if (found) {
        const updateList = {}
        Object.keys(found).forEach(k => {
          updateList[k] = {
            file: found[k]
          }
        })
        uploadAllFilesPromise(mainStorage, { callback: callback_afterUpload, action, files: found, appUserAccess, storageRef, handleStartUpdate, storageLocationType, _storageRefProd })

      }
      return state

    case rts.handleCloseUpdate:
      if (action && action.callback) { action.callback() }
      return { ...state, updating: false }

    case rts.handleUpdate_currentGalleryStatus:
      return { ...state, uploadUpdateStatus: getUploadGalleryStatus(state, action) }

    case rts.handleUpdate_singleItemStatus:
      const uus = getUploadSingleItemStatus(state)
      return { ...state, uploadUpdateStatus: uus, updating: uus.allComplete ? false : true }

    case rts.handleUpload_manifest:
      let smp2 = getManifestPath(action.pathViews ? action.pathViews : pathViews)
      if (smp2) {
        uploadManifestFiles(mainStorage, smp2, manifestFiles, appUserAccess).then(res => {
          console.log('handleUpload_manifest - success', manifestFiles)
          dispatch({ type: rts.updateSuccess, dispatch })
        }).catch(error => {
          console.log('handleUpload_manifest - error', error)
          dispatch({ type: rts.updateError, error, dispatch })
        })
      }
      return state

    case rts.handleSet_avatorEditor:
      return {
        ...state,
        avatarEditor: action.avatarEditor
      }

    case rts.handleDecline:
      return {
        ...state,
        selectedFolderFiles: null,
        firstSelectedFile: null,
        manifestFiles: null,
      }

    case rts.handleChange:
      return {
        ...state,
        description: action.data
      }

    case rts.handleProgress:
      return {
        ...state,
        progress: action.progress
      }

    case rts.handleAmmend_allFiles:
      ammendSelectedFiles(action, action.allFiles, handleSet_allFiles, handleManifestFiles)
      return { ...state, allFiles: action.allFiles }

    // case rts.handleAmmend_manifestFiles:
    //   ammendSelectedFiles(action, action.manifestFiles, handleSet_allFiles, handleManifestFiles)
    //   return { ...state, manifestFiles: action.manifestFiles }

    case rts.handleSet_allFiles:

      const { pendingFiles, selectedFiles } = getPending(state, action)

      const unSelectedFiles = getUnselected(action.selectedFolderFiles, selectedFiles)

      return {
        ...state,
        files_info: {
          selectedFolderFiles: action.selectedFolderFiles,
          allSelectedImages: action.allSelectedImages,
          firstSelectedFile: action.selectedFolderFiles ? action.selectedFolderFiles[0] : null,
          firstSelectedImage: action.allSelectedImages ? action.allSelectedImages[0] : null,
          selectedFiles,
          unSelectedFiles,
          uploadUpdateStatus: {},
          pendingFiles,
        },
      }

    case rts.handleUpdate_pendingFiles:
      return { ...state, files_info: { ...files_info, pendingFiles: action.pendingFiles } }

    case rts.handleManifestFiles:
      return {
        ...state,
        manifestFiles: action.manifestFiles
      }

    case rts.handleShowModalAlert:
      return {
        ...state,
        showAlertModal: action.show,
        importStarted: action.show
      }

    case rts.handleSet_imageImage:
      return {
        ...state,
        imageImage: action.imageImage,
        selectedFolderFiles: [action.imageImage]
      }

    case rts.handleUpdate_galleryDir:
      updateGalleryDir(pathViews, galleries)
      return state

    case rts.handleFileFormData:
      return { ...state, formData: action.formData }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleCloseUpdate:
    case rts.handleStopUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation, uploadUpdateStatus: getUploadUpdateStatus(state, action) })

    default:
      return state
  }
}

export const uploadHandlers = (dispatch) => {
  return {
    handleInit_upload: (initState) => { dispatch({ type: rts.handleInit_upload, initState }) },
    handleAmmend_allFiles: (allFiles, storageType) => { dispatch({ type: rts.handleAmmend_allFiles, dispatch, allFiles, storageType }) },
    handleAmmend_manifestFiles: (manifestFiles) => { dispatch({ type: rts.handleAmmend_manifestFiles, dispatch, manifestFiles }) },
    test: () => { dispatch({ type: rts.test }) },
    handleAccept: () => { dispatch({ type: rts.handleAccept }) },
    handleChange: (data) => { dispatch({ type: rts.handleChange, data }) },
    handleCloseUpdate: (action) => { dispatch({ type: rts.handleCloseUpdate, dispatch, action }) },
    handleDecline: () => { dispatch({ type: rts.handleDecline }) },
    handleFileFormData: (formData) => { dispatch({ type: rts.handleFileFormData, formData }) },
    handleImageButtonFileSelect: (f, storageType) => { dispatch({ type: rts.handleImageButtonFileSelect, dispatch, f, storageType }) },
    handleImageFileSelect: (e, storageType) => { dispatch({ type: rts.handleImageFileSelect, dispatch, e, storageType }) },
    handleManifestFiles: (manifestFiles) => { dispatch({ type: rts.handleManifestFiles, manifestFiles }) },
    handleProgress: (progress) => { dispatch({ type: rts.handleProgress, progress: progress }) },
    handleSet_allFiles: (selectedFolderFiles, allSelectedImages) => { dispatch({ type: rts.handleSet_allFiles, selectedFolderFiles, allSelectedImages }) },
    handleSet_avatorEditor: (avatarEditor) => { dispatch({ type: rts.handleSet_avatorEditor, avatarEditor }) },
    handleSet_imageImage: (imageImage) => { dispatch({ type: rts.handleSet_imageImage, imageImage }) },
    handleShowAlertModal: (show) => { dispatch({ type: rts.handleShowModalAlert, show }) },
    handleUpdate_currentGalleryStatus: (currentGallery, storageLocationType) => { dispatch({ type: rts.handleUpdate_currentGalleryStatus, dispatch, currentGallery, storageLocationType }) },
    handleUpdate_galleryDir: () => { dispatch({ type: rts.handleUpdate_galleryDir }) },
    handleUpdate_pendingFiles: (pendingFiles) => { dispatch({ type: rts.handleUpdate_pendingFiles, pendingFiles }) },
    handleUpdate_singleItemStatus: () => { dispatch({ type: rts.handleUpdate_singleItemStatus, dispatch }) },
    // handleUpload_alpha: (storageRef, fileList, useEmail, callback) => { dispatch({ type: rts.handleUpload_alpha, dispatch, storageRef, fileList, useEmail, callback }) },
    handleUpload_item: (fileKey) => { dispatch({ type: rts.handleUpload_item, dispatch, fileKey }) },
    handleUpload_manifest: (manifestFiles, pathViews) => { dispatch({ type: rts.handleUpload_manifest, dispatch, manifestFiles, pathViews }) },
    handleUpload_allFiles: () => { dispatch({ type: rts.handleUpload_allFiles, dispatch }) },
    // handleUpload_manual: (canvas, useAvatar, currentPageData) => { dispatch({ type: rts.handleUpload_manual, dispatch, canvas, useAvatar, currentPageData }) },
    handleUploadResponse: () => { dispatch({ type: rts.handleUploadResponse, dispatch }) },
    ...responseHandlers(dispatch)
  }
}

const getUpdateList = (selectedFolderFiles, currentPageData) => {
  const updateList = {}
  selectedFolderFiles.forEach(sff => {
    updateList[sff.name] = {
      file: {
        name: sff.name,
        fileImage: sff.fileImage
      },
      item: { ...currentPageData }
    }
  })
  return updateList
}

/**
 * 
 * @param {*} fileList 
 * @param {*} useEmail 
 * @returns 
 */
const getUploadApprovedList = (fileList, useEmail) => {
  const updateList = {}
  _.forEach(fileList, (item) => {
    const { fileStatusType, file, email, _itemKey } = item
    if (file && fileStatusType === fileStatusTypes.approved) {
      if (useEmail && email) {
        updateList[email] = {
          file: file,
          item: item,
        }
      } else {
        updateList[_itemKey] = {
          file: file,
          item: item,
        }
      }
    }
  })
  return updateList
}

export const uploadInitialState = (init_state) => {

  const {
    appUserAccess,
    appUserCollection,
    handleCancel,
    handlers,
    lastView,
    pathViews,
    productionSettings,
    showBulkUploader,
    storageOptions,
    storageRef,
    storageRootPath,
    storageType,
    useClientProfileImage,
    viewItemKey,
    viewListData,
    xxx,
    viewUploadProps,
    mainStorage,
  } = init_state

  let {
    storageLocationType
  } = init_state

  const { currentSettings_state, appUser, appStorageUrlFiles, galleries } = xxx ?? {}
  const { storage_handlers } = handlers ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { dataRestrictions } = aps_global ?? {}
  const { direct } = galleries ?? {}

  const { saveCollectionImagesToClient, clientStorageImageCollections } = storageOptions ?? {}

  let _allowAppUsersInClientProfiles = false;
  let _currentGallery;

  if (galleries && storageLocationType) {
    switch (storageLocationType) {
      case gEnums.storageLocationTypes.clientProfiles:
        _currentGallery = appStorageUrlFiles?.clientProfiles
        // _currentGallery = galleries[gEnums.storageLocationTypes.profiles]
        _allowAppUsersInClientProfiles = true
        break;
      case gEnums.storageLocationTypes.pages:
        if (saveCollectionImagesToClient && clientStorageImageCollections && clientStorageImageCollections.includes(lastView)) {
          storageLocationType = gEnums.storageLocationTypes.clientProfile
          _allowAppUsersInClientProfiles = true
        }
        break;
      default:
    }
  }

  const { pendingFiles } = getPending({ viewListData, showBulkUploader: true, currentGallery: _currentGallery })

  return {
    allowAppUsersInClientProfiles: _allowAppUsersInClientProfiles,
    appUser: appUser,
    appUserAccess,
    appUserCollection,
    avatarEditor: null,
    currentGallery: _currentGallery,
    dataRestrictions,
    description: null,
    showBulkUploader,
    galleryDirect: direct && direct[viewItemKey],
    handleCancel_showUpload: handleCancel,
    importStarted: false,
    isUploading: false,
    pathViews,
    pendingFiles,
    productionSettings,
    progress: 0,
    showAlertModal: false,
    storage_handlers,
    storageLocationType,
    storageOptions,
    storageRef,
    storageRootPath,
    storageType,
    uploadUpdateStatus: {},
    useClientProfileImage,
    viewListData,
    viewUploadProps,
    files_info: {},
    mainStorage,
  }
};

export const storageGalleryProps = (spProps) => {

  const {
    appUserAccess,
    dataItem,
    lastView,
    currentPageData,
    storageOptions,
    storagePaths,
    storageType,
    useClientProfileImage,
    useDarkMode,
    viewItem_id,
    viewItem_key,
    viewListData,
  } = spProps

  const { item: firstDataItem } = viewListData ? getFirstObject(viewListData) : {}
  const _dataItem = dataItem ? dataItem : firstDataItem
  let { email: _email } = _dataItem ?? {}

  let {
    storageLocationType,
  } = spProps

  const { galleryPaths } = _storageSettings ?? {}
  const { saveCollectionImagesToClient, clientStorageImageCollections } = storageOptions ?? {}

  const _isClientProfile = clientStorageImageCollections && clientStorageImageCollections.includes(viewItem_key) ? true : false

  if (!_email) { _email = appUserAccess.email }

  let _allowAppUsersInClientProfiles = false;

  if (storageLocationType && useClientProfileImage) {
    switch (storageLocationType) {
      case gEnums.storageLocationTypes.profileGallery:
        break;

      case gEnums.storageLocationTypes.clientProfiles:
        _allowAppUsersInClientProfiles = true
        break;

      case gEnums.storageLocationTypes.pages:
        if (saveCollectionImagesToClient && clientStorageImageCollections && clientStorageImageCollections.includes(lastView)) {
          if (_email) {
            storageLocationType = gEnums.storageLocationTypes.clientProfile
            _allowAppUsersInClientProfiles = true
          }
        }
        break;

      case gEnums.storageLocationTypes.pagePdf:
        // nothing
        break;

      default:
      // if (_isClientProfile) { storageLocationType = gEnums.storageLocationTypes.clientProfiles }
    }
  }

  switch (storageLocationType) {

    case gEnums.storageLocationTypes.clientProfiles:
      return {
        inClient: false,
        storageRef: storagePaths.clients + '/' + galleryPaths.profiles,
        collectionName: galleryPaths.profiles,
        useDarkMode: true,
        removeExisting: true,
        storageLocationType
      }

    case gEnums.storageLocationTypes.clientProfile:
      const { email: email_user } = currentPageData ?? {}
      const _profileEmail = email_user ? email_user : _email
      return {
        inClient: false,
        storageRef: storagePaths.clients + '/' + galleryPaths.profiles + '/' + _profileEmail, // appUserAccess.email,
        collectionName: galleryPaths.profiles,
        useDarkMode: true,
        removeExisting: true,
        storageLocationType
      }

    case gEnums.storageLocationTypes.event:
      if (storagePaths.events) {
        return {
          inClient: true,
          storageRef: storagePaths.events + '/' + storageType,
          collectionName: storageType,
          useDarkMode: true,
          storageLocationType
        }
      } else if (storagePaths.clients) {
        return {
          inClient: true,
          storageRef: storagePaths.clients + '/' + storageType,
          collectionName: storageType,
          useDarkMode: true,
          storageLocationType
        }
      } else {
        return {
          inClient: true,
          storageRef: 'home/' + storageType,
          collectionName: storageType,
          useDarkMode: true,
          storageLocationType
        }
      }

    case gEnums.storageLocationTypes.eventGallery:
      return {
        inClient: true,
        storageRef: storagePaths.events + '/' + galleryPaths.galleryEvent,
        collectionName: storageType,
        useDarkMode: true,
        storageLocationType
      }

    case gEnums.storageLocationTypes.pages:

      let sr;

      if (_allowAppUsersInClientProfiles) {
        sr = storagePaths.clients + '/' + _storageSettings.galleryPaths.profiles + '/' + _email
      } else {
        if (viewItem_id) {
          sr = storagePaths.events + '/' + galleryPaths.galleryDirect + '/' + viewItem_key + '/' + viewItem_id
        } else {
          sr = storagePaths.events + '/' + galleryPaths.galleryDirect + '/' + viewItem_key
        }
      }

      return {
        inClient: true,
        storageRef: sr,
        collectionName: galleryPaths.galleryDirect,
        useDarkMode: false,
        storageLocationType
      }

    case gEnums.storageLocationTypes.pageGallery:
      return {
        inClient: true,
        storageRef: storagePaths.events + '/' + galleryPaths.galleryPage + '/' + viewItem_key + '/' + viewItem_id,
        collectionName: galleryPaths.galleryPage,
        useDarkMode: false,
        storageLocationType
      }

    case gEnums.storageLocationTypes.pagePdf:
      return {
        inClient: true,
        storageRef: storagePaths.events + '/' + galleryPaths.pagePdf + '/' + viewItem_key + '/' + viewItem_id,
        collectionName: galleryPaths.pagePdf,
        useDarkMode: false,
        storageLocationType
      }

    case gEnums.storageLocationTypes.profileGallery:
      return {
        inClient: false,
        storageRef: galleryPaths.profile_all + '/' + appUserAccess.email,
        collectionName: galleryPaths.profile_all,
        useDarkMode: true,
        storageLocationType
      }

    case gEnums.storageLocationTypes.profiles:
      return {
        inClient: false,
        storageRef: galleryPaths.profiles + '/' + appUserAccess.email,
        collectionName: galleryPaths.profiles,
        useDarkMode: true,
        removeExisting: true,
        storageLocationType
      }

    default:
      return {
        inClient: true,
        storageRef: _storageSettings.galleryTypes.galleryDirect,
        useDarkMode,
        storageLocationType
      }
  }
}

const getFileName = (file, storageLocationType, selectedFolderFiles, altItemData, formData) => {
  let fileName;
  switch (storageLocationType) {
    case gEnums.storageLocationTypes.clientProfile:
    case gEnums.storageLocationTypes.clientProfiles:
    case gEnums.storageLocationTypes.pages:
    case gEnums.storageLocationTypes.profileGallery:
    case gEnums.storageLocationTypes.profiles:
      if (file.name.indexOf('-thumb') >= 0) {
        fileName = 'profile-thumb' // appUser.uid
      } else {
        fileName = 'profile' // appUser.uid
      }
      break;
    case gEnums.storageLocationTypes.pagePdf:
      fileName = formData.name
      break;
    default:
      if (selectedFolderFiles) {
        fileName = selectedFolderFiles[0].name
      }
  }
  if (altItemData && altItemData.email) { fileName = altItemData.email }
  return fileName
}

/**
 * 
 * @param {object} props (file, fileKey, appUserAccess, storageRef, handleStartUpdate)
 * @returns 
 */
export const uploadSingleFile = (mainStorage, props) => {

  const { file, fileKey, appUserAccess, storageRef, handleStartUpdate, formData } = props

  const metadata = {
    customMetadata: {
      uploadedBy: appUserAccess.email,
    }
  };

  if (formData && formData.name) {
    metadata.customMetadata.name = formData.name
  }

  const promises = []

  handleStartUpdate && handleStartUpdate({ fileKey })
  let _sr = storageRef
  if (fileKey) { _sr = _sr.replace('null', fileKey) }

  // create a thumbnail for the file
  createThumbnailIcons(file, true).then(res => {
    const allFiles = []
    // allFiles.push(file) // add the original
    res.forEach(r => { // add the thumbnails
      allFiles.push(new File([r], file.name + _storageSettings.thumbSuffix, { type: r.type }))
    })
    if (allFiles) {
      allFiles.forEach(file => {
        file.metadata = { name: 'test' }
        const _storageRef = ref(mainStorage, _sr + '/' + file.name)
        promises.push(uploadBytes(_storageRef, file, metadata))
      })
    }
  })
  return Promise.all(promises)
}


const uploadFilesPromise = async (mainStorage, props) => {

  const { callback, allFiles, storageRef, action } = props

  const urls = []

  for (const file of allFiles) {

    const _storageRef = ref(mainStorage, storageRef + `/${file.name}`);

    try {
      const snapshot = await uploadBytes(_storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log('File available at:', downloadURL);
      urls.push(downloadURL)
      // alert(`Image ${file.name} uploaded successfully!`);
    } catch (error) {
      console.error(`Error uploading file ${file.name}:`, error);
      // alert(`Error uploading image ${file.name}`);
    }
  }


  callback(action, urls)
}

/**
 * 
 * @param {object} props (callback, action, files, autoReduceImage, appUserAccess, storageRef, handleStartUpdate, storageLocationType, formData)
 */

const uploadAllFilesPromise = async (mainStorage, props) => {

  const {
    action,
    appUserAccess,
    // autoReduceImage,
    callback,
    files,
    formData,
    handleStartUpdate,
    storageLocationType,
    storageRef,
  } = props;

  const uploadAll = !action.fileKey;

  if (_.isEmpty(files) || (!uploadAll && !action.fileKey)) return;

  const metadata = {
    customMetadata: {
      uploadedBy: appUserAccess.email,
      ...(formData?.name && { name: formData.name }),
    },
  };

  const fileCount = _.size(files) * 2;
  let counter = 0;

  await Promise.all(

    _.map(files, async (fileItem, fileKey) => {
      const allowItem = uploadAll || fileKey === action.fileKey;

      if (!allowItem) return;

      handleStartUpdate?.({ fileKey });

      const { file, item } = fileItem;
      const { fileImage } = file

      const updatedMetadata = {
        ...metadata,
        customMetadata: {
          ...metadata.customMetadata,
          ...(item?.name && { name: item.name }),
          ...(item?.firstName && item?.lastName && { name: `${item.firstName} ${item.lastName}` }),
        },
      };

      if (fileImage?.type === 'application/pdf' || fileImage?.fileImage?.type === 'application/pdf') {
        updatedMetadata.contentType = 'application/pdf'
      }

      const prefix = _.includes(
        [
          gEnums.storageLocationTypes.pageGallery,
          gEnums.storageLocationTypes.profileGallery,
          gEnums.storageLocationTypes.clientProfiles,
        ],
        storageLocationType
      )
        ? `${fileKey}/`
        : '';

      const uploadFile = async (f, nameOverride = null) => {

        const fileName = nameOverride || f.name;
        const fullPath = `${storageRef}/${prefix}${fileName}`;
        const storageReference = ref(mainStorage, fullPath);


        await uploadBytes(storageReference, f, updatedMetadata);
        counter++;
        if (counter === fileCount) callback(action);
      };

      if (fileImage?.type === 'application/pdf' || fileImage?.fileImage?.type === 'application/pdf') {
        await uploadFile(fileImage.fileImage);
      } else {
        const thumbnailResults = await createThumbnailIcons(fileImage, true, true);
        const allFiles = [];

        // loop the thumbnailResults and add to allFies
        _.forEach(thumbnailResults, (thumbnailResult) => {
          const isThumbnail = _.includes(thumbnailResult?.name, 'n_200');
          let file_name = getFileName(thumbnailResult, storageLocationType, null, null, formData)
          if (!file_name && fileImage.name) {
            file_name = fileImage.name
          }
          if (isThumbnail) { file_name += _storageSettings.thumbSuffix }
          allFiles.push(new File([thumbnailResult], file_name, { type: thumbnailResult.type }));
        });

        await Promise.all(_.map(allFiles, (f) => uploadFile(f)));
      }
    })
  );
};

const uploadManifestFiles = async (mainStorage, storageRef, manifestFiles, appUserAccess) => {

  const metadata = {
    customMetadata: {
      uploadedBy: appUserAccess.email,
    }
  };

  const promises = []
  if (manifestFiles) {
    if (_.size(manifestFiles) < 10) {
      _.forEach(manifestFiles, (manifestFile) => {
        manifestFile.metadata = { name: 'test', user: appUserAccess.uid, email: appUserAccess.email }
        const _storageRef = ref(mainStorage, storageRef + '/' + manifestFile.name)
        promises.push(uploadBytes(_storageRef, manifestFile, metadata))
      })
    }
  }
  return Promise.all(promises)
}

const getUploadUpdateStatus = (state, action) => {
  const { uploadUpdateStatus } = state
  const { fileKey } = action
  const _updateStatus = { ...uploadUpdateStatus }
  if (!_updateStatus[fileKey]) { _updateStatus[fileKey] = {} }
  _updateStatus[fileKey].status = uploadStatusTypes.pending
  return _updateStatus
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns updateStatus for each item in the currentGallery
 */
const getUploadGalleryStatus = (state, action) => {
  const { uploadUpdateStatus, } = state
  const { currentGallery } = action ?? {}
  const _updateStatus = { ...uploadUpdateStatus }
  if (currentGallery) {
    Object.keys(currentGallery).forEach(fileKey => {
      if (!_updateStatus[fileKey]) { _updateStatus[fileKey] = {} }
      _updateStatus[fileKey].status = uploadStatusTypes.completed
    })
  }
  return _updateStatus
}

const getUploadSingleItemStatus = (state) => {
  const { uploadUpdateStatus, selectedFolderFiles } = state
  const _updateStatus = { ...uploadUpdateStatus }
  const allCount = selectedFolderFiles ? selectedFolderFiles.length : 0
  let successCount = 0
  if (selectedFolderFiles) {
    selectedFolderFiles.forEach(file => {
      const fileKey = file.name
      if (!_updateStatus[fileKey]) { _updateStatus[fileKey] = {} }
      _updateStatus[fileKey].status = uploadStatusTypes.completed
      successCount++
    })
  }
  if (allCount === successCount) {
    _updateStatus.allComplete = true
  }
  return _updateStatus
}

const getPending = (state, action, currentGallery) => {

  const { showBulkUploader, viewListData, currentGallery: currentGallery_state, allowAppUsersInClientProfiles } = state

  // selectedFolderFiles are the files from the hard drive or google photos
  const { selectedFolderFiles } = action ?? {}

  const _currentGallery = currentGallery || currentGallery_state

  const pendingFiles = {}
  const selectedFiles = []

  if (showBulkUploader && viewListData) {

    if (viewListData && selectedFolderFiles) {
      const x = matchFiles(viewListData, selectedFolderFiles)
    }

    // loop the data
    // _.forEach(viewListData, (dataItem, dataKey) => {

    // })

    Object.keys(viewListData).forEach(dataKey => {

      const dataItem = viewListData[dataKey]
      const { lastName, firstName, name, fullName, email } = dataItem

      pendingFiles[dataKey] = { _itemKey: dataKey, firstName, lastName, name: lastName ? lastName + ', ' + firstName : name, fullName, email }

      // the matching file
      const _file = selectedFolderFiles ? getFileFromName(selectedFolderFiles, dataKey, dataItem, pendingFiles) : null

      const _galleryItemKey = allowAppUsersInClientProfiles && email ? email : dataKey

      if (_file && _file.length === 1) {

        selectedFiles.push(_file)

        pendingFiles[dataKey].file = _file[0]
        // pendingFiles[dataKey].fileName = _file.name

        if (_currentGallery && _currentGallery[dataKey]) {
          pendingFiles[dataKey].fileStatusType = fileStatusTypes.existing
        } else {
          pendingFiles[dataKey].fileStatusType = fileStatusTypes.approved
        }
      } else {
        if (_currentGallery && _currentGallery[_galleryItemKey]) {
          const { urls } = _currentGallery[_galleryItemKey]
          pendingFiles[dataKey].urls = urls
          pendingFiles[dataKey].fileStatusType = fileStatusTypes.existing
        } else {
          pendingFiles[dataKey].fileStatusType = fileStatusTypes.missing
        }
      }
    })
  }

  return {
    pendingFiles,
    selectedFiles,
  }
}

const matchFiles = (viewListData, selectedFiles) => {
  const matchedFiles = [];

  _.forEach(selectedFiles, (selectedFile) => {
    const { name: name_file } = selectedFile
    const name_file_lower = name_file && name_file.toLowerCase().replace(/\s/g, ''); // Remove spaces
    _.forEach(viewListData, (item) => {
      const { name: name_item } = item ?? {}
      if (name_item) {
        const name_lower = name_file.toLowerCase().replace(/\s/g, ''); // Remove spaces 
        if (name_file_lower.includes(name_lower)) {
          matchedFiles.push({ name_file, fileName: name_file_lower });
        }
      }
    })
  })

  return matchedFiles
}

const getUnselected = (selectedFolderFiles, selectedFiles) => {
  const unSelectedFiles = []
  selectedFolderFiles.forEach(ssf => {
    const fi = _.find(selectedFiles, function (sf) {
      return (sf && (sf[0] === ssf));
    })
    if (!fi) { unSelectedFiles.push(ssf) }
  })
  return unSelectedFiles
}

const getFileFromName = (selectedFolderFiles, dataKey, dataItem, pendingFiles) => {

  const { lastName, firstName, name, fullName, email } = dataItem

  pendingFiles[dataKey] = { _itemKey: dataKey, firstName, lastName, name: lastName ? lastName + ', ' + firstName : name, fullName, email }

  const _ln = lastName && lastName.toLowerCase().replace("'", '')
  const _fn = firstName && firstName.toLowerCase()
  const _nm = name && name.toLowerCase()
  const _nmm = name && name.toLowerCase().replace(/\W/g, '')

  const _file = _.filter(selectedFolderFiles, function (sff) {
    const { name: name_file, fileImage } = sff
    let n = name_file.replace(/\W/g, '')
    n = n.replace('jpg', '')
    n = n.replace('png', '')
    if (_ln && _fn) {
      return (n.toLowerCase().indexOf(_fn) >= 0 && n.toLowerCase().indexOf(_ln) >= 0)
    } else {
      return (n.toLowerCase().indexOf(_nm) >= 0) || (n.toLowerCase().indexOf(_nmm) >= 0)
    }
  })

  switch (_file.length) {
    case 0:
      return;
    case 1:
      return _file
    default:
      const _file2 = _.filter(_file, function (f) {
        if (fullName) {
          const fullNameS = fullName.split(' ')
          let exists = true;
          fullNameS.forEach(fns => {
            if (f.name.indexOf(fns) < 0) {
              exists = false
            }
          })
          return exists
        }
      })

      switch (_file2.length) {
        case 0:
          return;
        case 1:
          return _file2
        default:
          return;
      }
  }
}

const updateGalleryDir = (pathViews, galleries) => {
  const { direct } = galleries ?? {}
  if (direct) {
    const _diss = {}
    Object.keys(direct).forEach(key => {
      const _dis = {}
      const di = direct[key]
      Object.keys(di).forEach(diKey => {
        const dii = di[diKey]
        const { pathz } = dii ?? {}
        const { full, thumbnail } = pathz ?? {}
        let _fullPath;
        let _thumbnail;
        if (full && full.indexOf('-thumb') < 0) {
          _fullPath = full
        } else if (full) {
          _fullPath = full.replace('-thumb', '')
        }
        if (thumbnail && thumbnail.indexOf('-thumb') < 0) {
          _thumbnail = thumbnail
        } else if (thumbnail) {
          _thumbnail = thumbnail.replace('-thumb', '')
        }
        const p = _fullPath ? _fullPath : _thumbnail
        _dis[diKey] = p //{ path: p }
      })
      _diss[key] = _dis
    })
    Object.keys(_diss).forEach(key => {
      const _did = _diss[key]
      const _refPath = createRefPath_event(pathViews, [_storageSettings.galleryPaths.galleryDirect, key])
      database_fns.set_doc(_refPath, _did).then(res => {
        // console.log('res', res)
      }).catch(error => {
        console.error(error);
      })
      // database_fns.update_dataCollection(pathViews, '_gallery_dir', key, _dis )
    })
  }
}

// const handleCompressedUpload = async (image) => {

//   new Compressor(image, {
//     quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
//     success: (compressedResult) => {
//       // compressedResult has the compressed file.
//       // Use the compressed file to upload the images to your server.        
//       setCompressedFile(compressedResult)
//     },
//   });
// };

const compressImage = (file) => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 0.6,
      minWidth: 500,
      maxHeight: 500,
      success: (compressedResult) => {
        // console.log('diff', compressedResult.size, compressedResult.size / file.size)
        resolve(compressedResult);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
};

const compressImages = async (files) => {
  try {
    // Check if 'files' is empty or not an object
    if (!files || Object.keys(files).length === 0) {
      return [];
    }

    const compressedFiles = await Promise.all(
      Object.keys(files).map(async (key) => {
        if (files?.[key]?.fileImage) {
          const compressedFile = await compressImage(files[key].fileImage);
          return compressedFile;
        }
      })
    );

    return compressedFiles;
  } catch (error) {
    console.error('Error compressing images:', error);
    return [];
  }
};


// const compressImages = async (files) => {
//   try {
//     // Check if 'files' is empty or not an object
//     if (!files || Object.keys(files).length === 0) {
//       return [];
//     }

//     const compressedFiles = await Promise.all(
//       Object.keys(files).map(async (key) => {
//         const file = files[key]?.fileImage; // Ensure fileImage exists
//         if (!file) return null; // Skip if fileImage is missing

//         const compressedFile = await compressImage(file);
//         return compressedFile;
//       })
//     );

//     // Filter out any null values in case some images failed compression
//     return compressedFiles.filter(Boolean);
//   } catch (error) {
//     console.error('Error compressing images:', error);
//     return [];
//   }
// };

const ammendSelectedFiles = async (action, files, handleSet_allFiles, handleManifestFiles) => {

  const { storageType } = action

  const _allSelectedFiles = [];
  const _allSelectedImages = []

  let _ammendedFiles;

  switch (storageType) {
    case gEnums.storageTypes.pdf:
      _ammendedFiles = files
      break;
    default:
      _ammendedFiles = await compressImages(files)
  }

  if (_.size(_ammendedFiles) > 0) {
    _.each(_ammendedFiles, (ammendedFile, key) => {
      if (ammendedFile) {
        _allSelectedFiles.push({
          name: ammendedFile.name,
          fileImage: ammendedFile
        })
      }
    })
  }

  switch (_allSelectedFiles.length) {
    case 1:
      switch (storageType) {
        case gEnums.storageTypes.manifest:
          const manifestName = 'manifest'
          const defaultFile = _allSelectedFiles[0].fileImage
          createManifestIcons(defaultFile).then(res => {
            const manifestFiles = []
            res.forEach((r, index) => {
              manifestFiles.push(new File([r], manifestName + '_' + index, { type: r.type }))
            })
            handleManifestFiles(manifestFiles, storageType)
          })
          break;
        case gEnums.storageTypes.pdf:
          handleSet_allFiles(_allSelectedFiles, _allSelectedImages)
          break;
        default:
          if (_allSelectedFiles) {
            _allSelectedFiles.forEach(item => {
              const obj = URL.createObjectURL(item.fileImage)
              _allSelectedImages.push(obj)
            })
          }
          handleSet_allFiles(_allSelectedFiles, _allSelectedImages)
      }
      break;
    default:
      handleSet_allFiles(_allSelectedFiles, _allSelectedImages)
      break;
  }
}